module.exports = __webpack_public_path__ + "img/batch_rent.png";